/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { c as components } from './_chunks/dep-11de1126.mjs';
export { LayoutEnum } from './common.mjs';
export { Button } from './button/index.mjs';
export { Icon } from './icon/index.mjs';
export { Link } from './link/index.mjs';
export { Col, Row } from './grid/index.mjs';
export { Aside, Content, Footer, Header, Layout } from './layout/index.mjs';
export { Divider } from './divider/index.mjs';
export { Space } from './space/index.mjs';
export { Descriptions, DescriptionsItem } from './descriptions/index.mjs';
export { Affix } from './affix/index.mjs';
export { Anchor, AnchorItem, AnchorTarget } from './anchor/index.mjs';
export { Breadcrumb, BreadcrumbItem } from './breadcrumb/index.mjs';
export { Dropdown, DropdownItem, DropdownMenu } from './dropdown/index.mjs';
export { HeadMenu, Menu, MenuGroup, MenuItem, Submenu } from './menu/index.mjs';
export { Pagination, PaginationMini } from './pagination/index.mjs';
export { StepItem, Steps } from './steps/index.mjs';
export { TabPanel, Tabs } from './tabs/index.mjs';
export { StickyItem, StickyTool } from './sticky-tool/index.mjs';
export { BackTop } from './back-top/index.mjs';
export { AutoComplete, HighlightOption } from './auto-complete/index.mjs';
export { Cascader, CascaderPanel } from './cascader/index.mjs';
export { Checkbox, CheckboxGroup } from './checkbox/index.mjs';
export { DatePicker, DatePickerPanel, DateRangePicker, DateRangePickerPanel } from './date-picker/index.mjs';
export { Form, FormItem } from './form/index.mjs';
export { InputAdornment } from './input-adornment/index.mjs';
export { Input, InputGroup } from './input/index.mjs';
export { InputNumber } from './input-number/index.mjs';
export { Radio, RadioButton, RadioGroup } from './radio/index.mjs';
export { Option, OptionGroup, Select } from './select/index.mjs';
export { Slider, SliderButton } from './slider/index.mjs';
export { Switch } from './switch/index.mjs';
export { TagInput } from './tag-input/index.mjs';
export { SelectInput } from './select-input/index.mjs';
export { Textarea } from './textarea/index.mjs';
export { Transfer } from './transfer/index.mjs';
export { TimePicker, TimePickerPanel, TimeRangePicker } from './time-picker/index.mjs';
export { TreeSelect } from './tree-select/index.mjs';
export { ColorPicker, ColorPickerPanel } from './color-picker/index.mjs';
export { RangeInput, RangeInputPopup } from './range-input/index.mjs';
export { Avatar, AvatarGroup } from './avatar/index.mjs';
export { Badge } from './badge/index.mjs';
export { Calendar } from './calendar/index.mjs';
export { Card } from './card/index.mjs';
export { Comment } from './comment/index.mjs';
export { Image } from './image/index.mjs';
export { ImageViewer } from './image-viewer/index.mjs';
export { List, ListItem, ListItemMeta } from './list/index.mjs';
export { Progress } from './progress/index.mjs';
export { Skeleton } from './skeleton/index.mjs';
export { Statistic } from './statistic/index.mjs';
export { Swiper, SwiperItem } from './swiper/index.mjs';
export { BaseTable, EnhancedTable, PrimaryTable, Table } from './table/index.mjs';
export { CheckTag, CheckTagGroup, Tag } from './tag/index.mjs';
export { Timeline, TimelineItem } from './timeline/index.mjs';
export { Tooltip } from './tooltip/index.mjs';
export { Tree } from './tree/index.mjs';
export { Collapse, CollapsePanel } from './collapse/index.mjs';
export { Watermark } from './watermark/index.mjs';
export { Rate } from './rate/index.mjs';
export { Alert } from './alert/index.mjs';
export { DialogPlugin } from './dialog/plugin.mjs';
export { Dialog } from './dialog/index.mjs';
export { Drawer } from './drawer/index.mjs';
export { Guide } from './guide/index.mjs';
export { default as LoadingPlugin } from './loading/plugin.mjs';
export { Loading } from './loading/index.mjs';
export { default as MessagePlugin } from './message/plugin.mjs';
export { Message } from './message/index.mjs';
export { default as NotifyPlugin } from './notification/plugin.mjs';
export { Notification } from './notification/index.mjs';
export { Popconfirm } from './popconfirm/index.mjs';
export { Popup } from './popup/index.mjs';
export { Upload } from './upload/index.mjs';
export { ConfigProvider } from './config-provider/index.mjs';
import './button/button.mjs';
import './_chunks/dep-f7837681.mjs';
import './_chunks/dep-6bcce672.mjs';
import './_chunks/dep-a26b9c60.mjs';
import './_chunks/dep-b333ab93.mjs';
import 'vue';
import './button/props.mjs';
import './hooks/useRipple.mjs';
import './hooks/useKeepAnimation.mjs';
import './hooks/useConfig.mjs';
import './config-provider/useConfig.mjs';
import './_chunks/dep-97c71289.mjs';
import './_chunks/dep-6f3e4f56.mjs';
import './_chunks/dep-b1060562.mjs';
import './_chunks/dep-4efc69ee.mjs';
import './_chunks/dep-493c38ce.mjs';
import './_chunks/dep-b56b2dc0.mjs';
import './_chunks/dep-77f634fb.mjs';
import './_chunks/dep-28ae3cda.mjs';
import './_chunks/dep-e50fa7b0.mjs';
import './_chunks/dep-ae08d6c4.mjs';
import './_chunks/dep-7211604f.mjs';
import './_chunks/dep-75df64b1.mjs';
import './_chunks/dep-48b9a098.mjs';
import './_chunks/dep-c7e4942d.mjs';
import './_chunks/dep-8049d2e0.mjs';
import './_chunks/dep-0d1bd08c.mjs';
import './_chunks/dep-c5d88cfe.mjs';
import './_chunks/dep-25d66c95.mjs';
import './_chunks/dep-372265bb.mjs';
import './_chunks/dep-d940e2da.mjs';
import './_chunks/dep-52c1d6a9.mjs';
import './_chunks/dep-18bb982b.mjs';
import './_chunks/dep-c57d8117.mjs';
import './_chunks/dep-6043e9fc.mjs';
import './_chunks/dep-5f6c8826.mjs';
import './_chunks/dep-3a045465.mjs';
import './_chunks/dep-53dc0ac1.mjs';
import './_chunks/dep-b6b4eaa3.mjs';
import './_chunks/dep-881cffb7.mjs';
import './_chunks/dep-436b338d.mjs';
import './_common/js/global-config/default-config.mjs';
import './_common/js/global-config/locale/zh_CN.mjs';
import './_chunks/dep-2d31a683.mjs';
import './_chunks/dep-3ddc95d0.mjs';
import './config-provider/type.mjs';
import './utils/set-style.mjs';
import './hooks/tnode.mjs';
import './_chunks/dep-0a6fd248.mjs';
import './_chunks/dep-7ad89920.mjs';
import './_chunks/dep-36563716.mjs';
import './_chunks/dep-b1013215.mjs';
import './_chunks/dep-91fc304f.mjs';
import './_chunks/dep-17446155.mjs';
import './_chunks/dep-8747fcf0.mjs';
import './utils/render-tnode.mjs';
import './_chunks/dep-ec227f3f.mjs';
import './hooks/useDisabled.mjs';
import './_chunks/dep-11ebe61f.mjs';
import './loading/directive.mjs';
import './loading/loading.mjs';
import './_chunks/dep-89b33ff6.mjs';
import './loading/icon/gradient.mjs';
import './_common/js/loading/circle-adapter.mjs';
import './_common/js/utils/set-style.mjs';
import './_common/js/utils/helper.mjs';
import './_chunks/dep-9c7a32ff.mjs';
import './_chunks/dep-c45cdd10.mjs';
import './_chunks/dep-ce88e3c0.mjs';
import './_chunks/dep-a432d90f.mjs';
import './utils/dom.mjs';
import './utils/easing.mjs';
import './loading/props.mjs';
import './hooks/useTeleport.mjs';
import './utils/withInstall.mjs';
import './style/css.mjs';
import './loading/type.mjs';
import './button/type.mjs';
import 'tdesign-icons-vue-next';
import './link/link.mjs';
import './link/props.mjs';
import './link/type.mjs';
import './grid/row.mjs';
import './grid/row-props.mjs';
import './grid/common.mjs';
import './utils/responsive.mjs';
import './hooks/useListener.mjs';
import './grid/col.mjs';
import './grid/col-props.mjs';
import './grid/type.mjs';
import './layout/layout.mjs';
import './layout/header.mjs';
import './layout/header-props.mjs';
import './layout/footer.mjs';
import './layout/footer-props.mjs';
import './layout/aside.mjs';
import './layout/aside-props.mjs';
import './layout/content.mjs';
import './layout/type.mjs';
import './divider/divider.mjs';
import './divider/props.mjs';
import './divider/type.mjs';
import './space/space.mjs';
import './space/props.mjs';
import './hooks/slot.mjs';
import './space/type.mjs';
import './descriptions/descriptions.mjs';
import './_chunks/dep-2311acd8.mjs';
import './descriptions/props.mjs';
import './descriptions/const/index.mjs';
import './descriptions/descriptions-row.mjs';
import './descriptions/utils/index.mjs';
import './descriptions/interface.mjs';
import './descriptions/descriptions-item.mjs';
import './descriptions/type.mjs';
import './affix/affix.mjs';
import './_chunks/dep-fc0ecd7a.mjs';
import './affix/props.mjs';
import './affix/type.mjs';
import './anchor/anchor.mjs';
import './anchor/utils.mjs';
import './anchor/props.mjs';
import './anchor/constants.mjs';
import './anchor/anchor-item.mjs';
import './anchor/anchor-item-props.mjs';
import './anchor/anchor-target.mjs';
import './utils/clipboard.mjs';
import './anchor/anchor-target-props.mjs';
import './hooks/useGlobalIcon.mjs';
import './message/messageList.mjs';
import './message/const.mjs';
import './message/message.mjs';
import './message/props.mjs';
import './message/animation.mjs';
import './popup/popup.mjs';
import '@popperjs/core';
import './_chunks/dep-9239b808.mjs';
import './_chunks/dep-8bda6dda.mjs';
import './hooks/index.mjs';
import './hooks/icon.mjs';
import './hooks/useCommonClassName.mjs';
import './hooks/useDefaultValue.mjs';
import './hooks/useDestroyOnClose.mjs';
import './hooks/useVirtualScroll.mjs';
import './hooks/useVModel.mjs';
import './hooks/useImagePreviewUrl.mjs';
import './_common/js/upload/utils.mjs';
import './_common/js/log/log.mjs';
import './popup/container.mjs';
import './popup/props.mjs';
import './hooks/useResizeObserver.mjs';
import './popup/type.mjs';
import './anchor/type.mjs';
import './breadcrumb/breadcrumb.mjs';
import './breadcrumb/props.mjs';
import './breadcrumb/breadcrumb-item.mjs';
import './breadcrumb/breadcrumb-item-props.mjs';
import './tooltip/tooltip.mjs';
import './_chunks/dep-7cc8d2c3.mjs';
import './_chunks/dep-6e04bcaa.mjs';
import './_chunks/dep-d23f3733.mjs';
import './_chunks/dep-4b3e18ca.mjs';
import './tooltip/props.mjs';
import './tooltip/util.mjs';
import './tooltip/type.mjs';
import './breadcrumb/type.mjs';
import './dropdown/dropdown-item.mjs';
import './dropdown/dropdown-item-props.mjs';
import './utils/helper.mjs';
import './dropdown/dropdown.mjs';
import './dropdown/dropdown-menu.mjs';
import './dropdown/props.mjs';
import './dropdown/hooks/useDropdownOptions.mjs';
import './dropdown/type.mjs';
import './menu/menu.mjs';
import './menu/props.mjs';
import './menu/v-menu.mjs';
import './_chunks/dep-6d195cc7.mjs';
import './menu/head-menu.mjs';
import './menu/head-menu-props.mjs';
import './menu/submenu.mjs';
import './menu/submenu-props.mjs';
import './common-components/fake-arrow.mjs';
import './hooks/useCollapseAnimation.mjs';
import './tabs/tabs.mjs';
import './tabs/tab-panel.mjs';
import './tabs/tab-panel-props.mjs';
import './tabs/tab-nav.mjs';
import './tabs/props.mjs';
import './_common/js/tabs/base.mjs';
import './tabs/tab-nav-item.mjs';
import './tabs/tab-nav-bar.mjs';
import './hooks/useDragSort.mjs';
import './tabs/type.mjs';
import './menu/menu-item.mjs';
import './menu/menu-item-props.mjs';
import './utils/event.mjs';
import './menu/menu-group.mjs';
import './menu/menu-group-props.mjs';
import './menu/type.mjs';
import './pagination/pagination.mjs';
import './pagination/props.mjs';
import './pagination/usePaginationClasses.mjs';
import './pagination/useMoreAction.mjs';
import './input-number/input-number.mjs';
import './input-number/props.mjs';
import './input-number/useInputNumber.mjs';
import './_common/js/input-number/number.mjs';
import './_common/js/input-number/large-number.mjs';
import './_common/js/log/index.mjs';
import './form/hooks.mjs';
import './input/input.mjs';
import './input/props.mjs';
import './input/useInput.mjs';
import './form/const.mjs';
import './input/useLengthLimit.mjs';
import './input/useInputEventHandler.mjs';
import './input/useInputWidth.mjs';
import './input/input-group.mjs';
import './input/input-group-props.mjs';
import './input/type.mjs';
import './input-number/type.mjs';
import './select/select.mjs';
import './_chunks/dep-d31cdc42.mjs';
import './_chunks/dep-31e6cb80.mjs';
import './_chunks/dep-87c358ba.mjs';
import './_chunks/dep-c0b45aa7.mjs';
import './_chunks/dep-8a9a248b.mjs';
import './select/select-panel.mjs';
import './select/option.mjs';
import './select/option-props.mjs';
import './select/helper.mjs';
import './checkbox/checkbox.mjs';
import './checkbox/props.mjs';
import './checkbox/constants.mjs';
import './checkbox/hooks/useCheckboxLazyLoad.mjs';
import './_common/js/utils/observe.mjs';
import './checkbox/hooks/useKeyboardEvent.mjs';
import './_common/js/common.mjs';
import './checkbox/group.mjs';
import './checkbox/checkbox-group-props.mjs';
import './checkbox/type.mjs';
import './select/optionGroup.mjs';
import './select/option-group-props.mjs';
import './select/props.mjs';
import './select/hooks/usePanelVirtualScroll.mjs';
import './select/hooks/useSelectOptions.mjs';
import './select/hooks/useKeyboardControl.mjs';
import './select-input/select-input.mjs';
import './select-input/props.mjs';
import './select-input/useSingle.mjs';
import './select-input/useMultiple.mjs';
import './tag-input/tag-input.mjs';
import './tag-input/props.mjs';
import './tag-input/hooks/useTagScroll.mjs';
import './tag-input/useTagList.mjs';
import './tag/tag.mjs';
import './tag/props.mjs';
import './tag/check-tag.mjs';
import './tag/check-tag-props.mjs';
import './tag/check-tag-group.mjs';
import './tag/check-tag-group-props.mjs';
import './tag/type.mjs';
import './tag-input/hooks/useHover.mjs';
import './tag-input/hooks/useDragSorter.mjs';
import './tag-input/type.mjs';
import './select-input/useOverlayInnerStyle.mjs';
import './select-input/type.mjs';
import './select/type.mjs';
import './input-adornment/input-adornment.mjs';
import './input-adornment/props.mjs';
import './input-adornment/type.mjs';
import './pagination/pagination-mini.mjs';
import './pagination/pagination-mini-props.mjs';
import './pagination/type.mjs';
import './steps/steps.mjs';
import './steps/props.mjs';
import './steps/step-item-props.mjs';
import './steps/step-item.mjs';
import './steps/type.mjs';
import './sticky-tool/sticky-tool.mjs';
import './sticky-tool/props.mjs';
import './sticky-tool/sticky-item.mjs';
import './sticky-tool/sticky-item-props.mjs';
import './sticky-tool/type.mjs';
import './back-top/back-top.mjs';
import './back-top/props.mjs';
import './back-top/type.mjs';
import './auto-complete/auto-complete.mjs';
import './auto-complete/props.mjs';
import './auto-complete/option-list.mjs';
import './_chunks/dep-c49a32e5.mjs';
import './auto-complete/type.mjs';
import './cascader/cascader.mjs';
import './cascader/components/Panel.mjs';
import './cascader/components/Item.mjs';
import './cascader/core/helper.mjs';
import './cascader/core/className.mjs';
import './cascader/props.mjs';
import './cascader/core/effect.mjs';
import './cascader/hooks.mjs';
import './_chunks/dep-a3455aed.mjs';
import './_chunks/dep-89a3e1c4.mjs';
import './_common/js/tree/tree-store.mjs';
import './_chunks/dep-4826cf61.mjs';
import 'mitt';
import './_common/js/tree/tree-node.mjs';
import './_common/js/tree/tree-node-model.mjs';
import './cascader/cascader-panel.mjs';
import './cascader/type.mjs';
import './date-picker/DatePicker.mjs';
import './date-picker/hooks/useSingle.mjs';
import './_chunks/dep-d8503ac7.mjs';
import './_chunks/dep-f373784b.mjs';
import './date-picker/hooks/useSingleValue.mjs';
import './date-picker/props.mjs';
import './date-picker/panel/SinglePanel.mjs';
import './date-picker/panel/PanelContent.mjs';
import './date-picker/base/Header.mjs';
import './date-picker/base/Table.mjs';
import './date-picker/base/Cell.mjs';
import './time-picker/panel/time-picker-panel.mjs';
import './_common/js/time-picker/const.mjs';
import './time-picker/panel/props.mjs';
import './time-picker/props.mjs';
import './time-picker/panel/single-panel.mjs';
import './_chunks/dep-af80a136.mjs';
import './_common/js/time-picker/utils.mjs';
import './date-picker/panel/ExtraContent.mjs';
import './date-picker/base/Footer.mjs';
import './date-picker/hooks/useTableData.mjs';
import './date-picker/hooks/useDisableDate.mjs';
import './date-picker/DatePickerPanel.mjs';
import './date-picker/date-picker-panel-props.mjs';
import './date-picker/DateRangePicker.mjs';
import './date-picker/date-range-picker-props.mjs';
import './date-picker/panel/RangePanel.mjs';
import './date-picker/hooks/useRange.mjs';
import './date-picker/hooks/useRangeValue.mjs';
import './range-input/range-input.mjs';
import './range-input/props.mjs';
import './range-input/range-input-popup.mjs';
import './range-input/range-input-popup-props.mjs';
import './range-input/type.mjs';
import './date-picker/DateRangePickerPanel.mjs';
import './date-picker/date-range-picker-panel-props.mjs';
import './date-picker/type.mjs';
import './form/form.mjs';
import './form/form-item.mjs';
import './_chunks/dep-992f6364.mjs';
import './form/form-model.mjs';
import './form/form-item-props.mjs';
import './form/props.mjs';
import './form/type.mjs';
import './radio/radio.mjs';
import './radio/props.mjs';
import './radio/constants.mjs';
import './radio/group.mjs';
import './_chunks/dep-99b45a9d.mjs';
import './radio/radio-group-props.mjs';
import './radio/useKeyboard.mjs';
import './watermark/hooks.mjs';
import './radio/radio-button.mjs';
import './radio/type.mjs';
import './slider/slider.mjs';
import './slider/props.mjs';
import './slider/slider-button.mjs';
import './slider/hooks/useSliderTooltip.mjs';
import './slider/util/common.mjs';
import './slider/util/constants.mjs';
import './slider/hooks/useSliderMark.mjs';
import './slider/slider-mark.mjs';
import './slider/hooks/useSliderInput.mjs';
import './slider/type.mjs';
import './switch/switch.mjs';
import './switch/props.mjs';
import './switch/type.mjs';
import './textarea/textarea.mjs';
import './textarea/calcTextareaHeight.mjs';
import './textarea/props.mjs';
import './textarea/type.mjs';
import './transfer/transfer.mjs';
import './transfer/components/transfer-list.mjs';
import './transfer/utils.mjs';
import './transfer/components/transfer-search.mjs';
import './_chunks/dep-185c8418.mjs';
import './transfer/hooks/useDragSort.mjs';
import './transfer/components/transfer-operations.mjs';
import './transfer/props.mjs';
import './time-picker/time-picker.mjs';
import './time-picker/time-range-picker.mjs';
import './time-picker/time-range-picker-props.mjs';
import './time-picker/type.mjs';
import './tree-select/tree-select.mjs';
import './tree-select/props.mjs';
import './tree/tree.mjs';
import './tree/adapt.mjs';
import './hooks/useLazyLoad.mjs';
import './hooks/useVirtualScrollNew.mjs';
import './tree/props.mjs';
import './tree/hooks/useTreeStore.mjs';
import './tree/hooks/useTreeStyles.mjs';
import './tree/hooks/useTreeState.mjs';
import './tree/hooks/useTreeAction.mjs';
import './tree/util.mjs';
import './tree/hooks/useTreeScroll.mjs';
import './tree/hooks/useTreeNodes.mjs';
import './tree/tree-item.mjs';
import './tree/hooks/useItemState.mjs';
import './tree/hooks/useTreeItem.mjs';
import './tree/hooks/useItemEvents.mjs';
import './tree/hooks/useRenderIcon.mjs';
import './tree/hooks/useRenderLabel.mjs';
import './tree/hooks/useRenderLine.mjs';
import './tree/hooks/useRenderOperations.mjs';
import './tree/hooks/useDraggable.mjs';
import './tree/hooks/useTreeEvents.mjs';
import './tree/hooks/useDragHandle.mjs';
import './tree/tree-types.mjs';
import './tree/type.mjs';
import './tree-select/interface.mjs';
import './tree-select/type.mjs';
import './color-picker/color-picker-panel.mjs';
import './color-picker/props.mjs';
import './color-picker/panel/index.mjs';
import './color-picker/const.mjs';
import './_common/js/color-picker/constants.mjs';
import './color-picker/panel/header.mjs';
import './color-picker/hooks.mjs';
import './color-picker/panel/linear-gradient.mjs';
import './color-picker/utils/index.mjs';
import './_common/js/color-picker/index.mjs';
import './_common/js/color-picker/cmyk.mjs';
import './_common/js/color-picker/color.mjs';
import './_chunks/dep-71e8e343.mjs';
import './_common/js/color-picker/draggable.mjs';
import './color-picker/panel/base-props.mjs';
import './color-picker/panel/saturation.mjs';
import './color-picker/panel/hue.mjs';
import './color-picker/panel/slider.mjs';
import './color-picker/panel/alpha.mjs';
import './color-picker/panel/format/index.mjs';
import './color-picker/panel/format/inputs.mjs';
import './color-picker/panel/format/config.mjs';
import './color-picker/panel/swatches.mjs';
import './color-picker/color-picker.mjs';
import './color-picker/trigger.mjs';
import './color-picker/type.mjs';
import './avatar/avatar.mjs';
import './avatar/props.mjs';
import './image/image.mjs';
import './image/props.mjs';
import './image/type.mjs';
import './avatar/group.mjs';
import './avatar/avatar-group-props.mjs';
import './avatar/type.mjs';
import './badge/badge.mjs';
import './badge/props.mjs';
import './badge/type.mjs';
import './calendar/calendar.mjs';
import './calendar/props.mjs';
import './calendar/utils.mjs';
import './calendar/const.mjs';
import './calendar/hook/index.mjs';
import './calendar/hook/useState.mjs';
import './calendar/hook/useCalendarClass.mjs';
import './calendar/hook/useController.mjs';
import './calendar/hook/useColHeaders.mjs';
import './calendar/calendar-cell.mjs';
import './calendar/type.mjs';
import './card/card.mjs';
import './card/props.mjs';
import './card/type.mjs';
import './comment/comment.mjs';
import './comment/props.mjs';
import './comment/type.mjs';
import './image-viewer/image-viewer.mjs';
import './image-viewer/props.mjs';
import './image-viewer/base/ImageModalIcon.mjs';
import './image-viewer/base/ImageViewerUtils.mjs';
import './image-viewer/utils.mjs';
import './image-viewer/base/ImageItem.mjs';
import './image-viewer/hooks.mjs';
import './image-viewer/base/ImageViewerModal.mjs';
import './dialog/dialog.mjs';
import './dialog/props.mjs';
import './dialog/hooks.mjs';
import './_common/js/utils/getScrollbarWidth.mjs';
import './hooks/usePopupManager.mjs';
import './dialog/type.mjs';
import './image-viewer/const.mjs';
import './image-viewer/type.mjs';
import './list/list.mjs';
import './list/list-item.mjs';
import './list/props.mjs';
import './list/const.mjs';
import './list/hooks/useListItems.mjs';
import './list/hooks/useListVirtualScroll.mjs';
import './list/list-item-meta.mjs';
import './list/list-item-meta-props.mjs';
import './list/type.mjs';
import './progress/progress.mjs';
import './progress/constants.mjs';
import './progress/props.mjs';
import './progress/type.mjs';
import './skeleton/skeleton.mjs';
import './skeleton/props.mjs';
import './skeleton/type.mjs';
import './statistic/statistic.mjs';
import './statistic/props.mjs';
import './_common/js/statistic/tween.mjs';
import './_common/js/statistic/utils.mjs';
import './statistic/type.mjs';
import './swiper/swiper.mjs';
import './swiper/props.mjs';
import './swiper/swiper-item.mjs';
import './swiper/type.mjs';
import './table/base-table.mjs';
import './table/base-table-props.mjs';
import './table/hooks/useTableHeader.mjs';
import './table/hooks/useMultiHeader.mjs';
import './table/hooks/useClassName.mjs';
import './table/ellipsis.mjs';
import './table/hooks/useColumnResize.mjs';
import './table/hooks/useFixed.mjs';
import './table/hooks/usePagination.mjs';
import './table/hooks/useAffix.mjs';
import './table/tbody.mjs';
import './table/tr.mjs';
import './table/utils.mjs';
import './table/hooks/useLazyLoad.mjs';
import './table/hooks/useRowspanAndColspan.mjs';
import './table/hooks/useStyle.mjs';
import './table/thead.mjs';
import './table/tfoot.mjs';
import './table/hooks/useRowHighlight.mjs';
import './table/hooks/useHoverKeyboardEvent.mjs';
import './hooks/useElementLazyRender.mjs';
import './table/primary-table.mjs';
import './table/primary-table-props.mjs';
import './table/hooks/useColumnController.mjs';
import './table/column-checkbox-group.mjs';
import './table/hooks/useRowExpand.mjs';
import './table/hooks/useRowSelect.mjs';
import './_common/js/table/utils.mjs';
import './table/hooks/useSorter.mjs';
import './table/sorter-button.mjs';
import './table/hooks/useFilter.mjs';
import './table/filter-controller.mjs';
import './table/hooks/useDragSort.mjs';
import 'sortablejs';
import './_common/js/utils/swapDragArrayElement.mjs';
import './table/hooks/useAsyncLoading.mjs';
import './table/editable-cell.mjs';
import './_chunks/dep-ae77ef8a.mjs';
import './table/hooks/useEditableRow.mjs';
import './table/enhanced-table.mjs';
import './table/enhanced-table-props.mjs';
import './table/hooks/useTreeData.mjs';
import './_common/js/table/tree-store.mjs';
import './table/hooks/useTreeDataExpand.mjs';
import './table/hooks/useTreeSelect.mjs';
import './table/type.mjs';
import './table/interface.mjs';
import './timeline/timeline.mjs';
import './timeline/props.mjs';
import './timeline/hooks.mjs';
import './timeline/timeline-item.mjs';
import './timeline/timeline-item-props.mjs';
import './timeline/type.mjs';
import './collapse/collapse.mjs';
import './collapse/props.mjs';
import './collapse/collapse-panel.mjs';
import './collapse/collapse-panel-props.mjs';
import './collapse/type.mjs';
import './watermark/watermark.mjs';
import './watermark/props.mjs';
import './_common/js/watermark/generateBase64Url.mjs';
import './_common/js/watermark/randomMovingStyle.mjs';
import './_common/js/utils/injectStyle.mjs';
import './watermark/type.mjs';
import './rate/rate.mjs';
import './rate/props.mjs';
import './rate/type.mjs';
import './alert/alert.mjs';
import './alert/props.mjs';
import './alert/type.mjs';
import './drawer/drawer.mjs';
import './drawer/props.mjs';
import './drawer/hooks.mjs';
import './drawer/type.mjs';
import './guide/guide.mjs';
import './guide/props.mjs';
import './guide/utils/index.mjs';
import './guide/utils/getScrollParent.mjs';
import './guide/utils/getRelativePosition.mjs';
import './guide/utils/getTargetElm.mjs';
import './guide/utils/scrollToElm.mjs';
import './guide/type.mjs';
import './message/type.mjs';
import './notification/notificationList.mjs';
import './notification/notification.mjs';
import './notification/props.mjs';
import './notification/animate.mjs';
import './notification/const.mjs';
import './notification/type.mjs';
import './popconfirm/popconfirm.mjs';
import './popconfirm/props.mjs';
import './popconfirm/type.mjs';
import './upload/upload.mjs';
import './upload/props.mjs';
import './upload/themes/normal-file.mjs';
import './upload/constants.mjs';
import './upload/themes/dragger-file.mjs';
import './upload/hooks/useDrag.mjs';
import './upload/themes/image-card.mjs';
import './upload/themes/multiple-flow-list.mjs';
import './upload/hooks/useUpload.mjs';
import './_common/js/upload/main.mjs';
import './_common/js/upload/xhr.mjs';
import './upload/themes/custom-file.mjs';
import './upload/interface.mjs';
import './upload/type.mjs';
import './config-provider/config-provider.mjs';

function install(app, config) {
  Object.keys(components).forEach(function (key) {
    /plugin/i.test(key) ? app.use(components[key]) : app.use(components[key], config);
  });
}
var index = {
  install: install,
  version: typeof "1.8.0" === "undefined" ? "" : "1.8.0"
};

export { index as default, install };
//# sourceMappingURL=index.mjs.map
